<template>
  <div
    class="d-flex pa-2 flex-row flex-wrap"
    :style="{ height: 'fit-content' }"
  >
    <card-row :title="'Search'" :cardColor="'white'" :displayed="true">
      <div style="width: 100%">
        <v-row>
          <v-col cols="12" sm="6" md="3">
            <v-dialog
              ref="rangeDateDialog"
              v-model="rangeDateDialog"
              :return-value.sync="searchData.trx_datetime"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  id="rangeDate"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  v-model="dateRangeText"
                  label="Transaction Date"
                  hide-details="true"
                  dense
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="searchData.trx_datetime"
                scrollable
                range
                :min="minDate"
                :max="maxDate"
              >
                <v-spacer></v-spacer>
                <v-btn text color="accent" @click="rangeDateDialog = false">
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="accent"
                  @click="
                    () => {
                      checkRangeDate(searchData.trx_datetime);
                      $refs.rangeDateDialog.save(searchData.trx_datetime);
                    }
                  "
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-dialog>
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <v-autocomplete
              id="ac_id"
              ref="ac_id"
              :search-input.sync="searchAggregator"
              v-model="searchData.ac_id"
              :items="aggregatorList"
              hide-selected
              label="Aggregator Name"
              persistent-hint
              item-value="ac_id"
              item-text="merchant_name"
              :loading="loadingAggregator"
              hide-details="true"
              clearable
              dense
            />
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <v-select
              v-model="searchData.payment_type"
              :items="listPaymentType"
              label="Payment Type"
              item-text="text"
              item-value="value"
              clearable
              hide-details="true"
              dense
            ></v-select>
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <v-text-field
              v-model="searchData.rrn"
              label="Reff ID"
              type="text"
              hide-details="true"
              dense
            ></v-text-field>
          </v-col>

          <v-col v-if="midShowed" cols="12" sm="6" md="6">
            <v-autocomplete
              id="merchants"
              ref="merchants"
              :search-input.sync="searchMerchant"
              v-model="searchData.mid"
              :items="merchantList"
              hide-selected
              label="MID"
              persistent-hint
              item-value="mid"
              item-text="mid"
              :loading="loadingMerchant"
              hint="Search by MID"
              clearable
              dense
            >
              <template v-slot:item="{ item }">
                {{ item.mid + ' - ' + item.merchant_name }}
              </template>
            </v-autocomplete>
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <v-text-field
              v-model="searchData.bill_num"
              label="Bill Number"
              type="text"
              hide-details="true"
              dense
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <v-select
              v-model="searchData.status"
              :items="listTrxReportStatus"
              label="Status"
              item-text="text"
              item-value="value"
              clearable
              hide-details="true"
              dense
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="4" v-if="!isCPM">
            <v-select
              v-model="searchData.promo_code"
              :items="promoCodeFilter"
              label="Switcher"
              item-text="text"
              item-value="value"
              clearable
              hide-details="true"
              dense
              :disabled="switcherDisabled"
            ></v-select>
          </v-col>
        </v-row>
        <v-row class="d-flex align-center justify-left">
          <v-col cols="12">
            <v-btn @click="clearSearch"> Reset </v-btn>
            <v-btn
              color="primary"
              class="ml-2"
              @click.stop="getData"
              :loading="loading"
              >show</v-btn
            >
          </v-col>
        </v-row>
      </div>
    </card-row>
  </div>
</template>

<script>
import {
  dataListPaymentType,
  dataListTrxReportStatus,
  dataMinRangeDate,
  dataMaxRangeDate,
  promoCodeFilter
} from '../../store/params';
import { getDate, date } from '../../lib/helpers';

export default {
  components: { CardRow: () => import('../CardRow.vue') },
  props: ['search', 'loading', 'type', 'module'],
  data: () => ({
    today: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0, 10),
    loadingAggregator: false,
    loadingMerchant: false,
    listPaymentType: dataListPaymentType,
    listTrxReportStatus: dataListTrxReportStatus,
    promoCodeFilter,
    rangeDateDialog: false,
    searchAggregator: '',
    searchMerchant: '',
    acId: null,
    mId: null,
    midShow: false,
    switcherDisabled: false,
  }),
  watch: {
    'searchData.payment_type': {
      handler(val) {
        if (val === 'on us') {
          this.switcherDisabled = true;
          this.$set(this.searchData, 'promo_code', '');
        } else {
          this.switcherDisabled = false;
        }
      },
      immediate: true,
    },
    'searchData.promo_code': {
      handler(val) {
        if (val && (!this.searchData.payment_type || this.searchData.payment_type === 'on us')) {
          this.$set(this.searchData, 'payment_type', 'off us');
        }
      },
    },
    'searchData.ac_id': {
      handler(val) {
        if (!val) {
          this.searchData.mid = '';
          this.$store.commit('report/clearMerchant');
        }
      },
    },
    searchAggregator(val) {
      if (val && val.length >= 3) {
        this.acId = val;
        this.getAggregator();
      } else {
        this.acId = '';
        this.$store.commit('report/clearAggregator');
        this.$store.commit('report/clearMerchant');
      }
    },
    searchMerchant(val) {
      if (val && val.length >= 3) {
        this.mId = val;
        this.getMerchant();
      } else {
        this.mId = '';
        this.$store.commit('report/clearMerchant');
      }
    },
  },
  computed: {
    isCPM() {
      return this.module === 'cpm';
    },
    searchData: {
      get() {
        return this.search;
      },
      set(newValue) {
        this.$emit('update:search', newValue);
      },
    },
    allowMid() {
      return this.type === 'direceMid';
    },
    midShowed() {
      const acId = this.searchData.ac_id;
      return acId || this.allowMid;
    },
    dateRangeText() {
      return this.searchData.trx_datetime.join(' ~ ');
    },
    aggregatorList() {
      return this.$store.state.report.aggregatorList;
    },
    merchantList() {
      return this.$store.state.report.merchantList;
    },
    minDate() {
      if (this.searchData.trx_datetime.length > 0) {
        const tempMinDate = Date.parse(this.searchData.trx_datetime[0]);
        return this.getDate(dataMinRangeDate, tempMinDate);
      }
      return '';
    },
    maxDate() {
      if (this.searchData.trx_datetime.length > 0) {
        const tempMaxDate = Date.parse(this.searchData.trx_datetime[0]);
        const maxDate = this.getDate(dataMaxRangeDate, tempMaxDate);
        return maxDate > this.today ? this.today : maxDate;
      }
      return this.today;
    },
  },
  methods: {
    getAggregator() {
      this.loadingAggregator = true;
      this.$store.commit('report/setFlashErrorMessage', '');
      this.$store
        .dispatch('report/getAggregator', {
          date,
          sortBy: 'ID',
          search: { name: this.acId },
        })
        .then(() => {
          this.loadingAggregator = false;
        });
    },
    getMerchant() {
      let sourceMethod = 'aggregator';
      if (this.allowMid && !this.searchData.ac_id) {
        sourceMethod = 'merchant';
      }
      this.loadingMerchant = true;
      this.$store.commit('report/setFlashErrorMessage', '');
      this.$store
        .dispatch('report/getMerchant', {
          date,
          sortBy: 'ID',
          search: { ac_id: this.searchData.ac_id, mid: this.mId },
          source: sourceMethod,
        })
        .then(() => {
          this.loadingMerchant = false;
        });
    },

    checkRangeDate(trx_datetime) {
      trx_datetime.sort();
      if (trx_datetime.length == 1) {
        trx_datetime.push(this.searchData.trx_datetime[0]);
      }
    },

    clearSearch() {
      this.$emit('clearSearchParent');
    },
    getData() {
      this.$emit('getDataParent');
    },
    getDate,
  },
};
</script>
